import {ENDPOINT_URL} from '../constants/index';
import {apiErrorHandling} from '../utils/apiUtils';

import getFetchOptions from '../utils/getFetchOptions';

export default function updateUserTime() {
	return fetch(
		`${ENDPOINT_URL}/updateusertime`,
		getFetchOptions({
			method: 'PUT',
		})
	)
		.then((response) => {
			if (!response.ok) {
				throw response;
			}
			return response.json();
		})
		.catch((err) => {
			return Promise.reject(apiErrorHandling(err));
		});
}
/* 
/adminuserself/:id
*/
